<template>
  <div class="size-finder__tab size-finder__tab--garment-measurements">
    <h4
      v-if="tabContent.paragraphTitle"
      class="size-finder__tab-heading text-body-m-bold"
      v-text="tabContent.paragraphTitle"
    />

    <div
      v-if="tabContent.paragraphContent"
      class="size-finder__tab-paragraph"
      v-html="tabContent.paragraphContent"
    />

    <size-table
      :table-source="activeGuideTable"
      :enable-unit-toggle="enableUnitToggle"
    />
  </div>
</template>

<script>
import SizeTable from './size-table'

export default {
  name: 'GarmentMeasurementsTab',

  components: {
    SizeTable,
  },

  props: {
    tabContent: {
      type: Object,
      default: () => ({}),
    },
    enableUnitToggle: {
      type: [Boolean, Object],
      default: true,
    },
  },

  data() {
    return {
      activeGuideTable: '',
    }
  },

  mounted() {
    this.getActiveGuide()
  },

  methods: {

    /**
     * Get active size guide table source.
     */
    getActiveGuide() {
      this.activeGuideTable = this.tabContent.tables.gb
    },
  },
}
</script>
